import { FadeUp, MaskedLines, Eyebrow } from "@/components/Reveal";
import SilkTexture, { SILK } from "@/components/SilkTexture";

const PRINCIPLES = [
  {
    n: "01",
    title: "Kürasyon",
    sub: "Kimyayı tesadüfe bırakıyoruz, uyumu değil.",
    paras: [
      "Seçtiğin ilişki enerjisi ve verdiğin yanıtlarla, aşka ve geleceğe seninle benzer yerden bakan insanları bir araya getiriyoruz.",
      "Çünkü birinden hoşlanmak zaten yeterince kompleks. Bir de en temel şeylerde bambaşka yönlere bakıyor olmanız gerekmiyor. Biz o sürtünmeyi en baştan azaltıyoruz. Kimyayı tesadüfe bırakıyoruz, uyumu değil.",
    ],
  },
  {
    n: "02",
    title: "Güvenlik & Gizlilik",
    sub: "Daha seçilmiş, daha özel bir deneyim.",
    paras: [
      "Profillerin değerlendirilerek sürece dahil edilmesi, karşına çıkan kişilerin de belirli bir eleme sürecinden geçtiğini bilmeni sağlar. Böylece tanıştığın kişiler konusunda daha güvenilir bir zemin oluşturmayı hedefliyoruz.",
      "Profilin ise herkese açık bir akışta yer almıyor; yalnızca senin için seçilen kişilerle paylaşılıyor. Böylece yeni insanlarla tanışırken özel hayatın daha kontrollü ve gizli kalıyor.",
    ],
  },
  {
    n: "03",
    title: "Geri Bildirim",
    sub: null,
    paras: ["Deneyimin, sonraki seçimlerin şekillenmesine yardımcı olur."],
  },
];

export default function Why() {
  return (
    <section data-testid="why-section" className="py-24 sm:py-36 bg-ivory relative overflow-hidden">
      <SilkTexture src={SILK.flow} side="right" opacity={0.22} speed={70} className="hidden lg:block" />
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <FadeUp>
              <Eyebrow>Neden Five Star</Eyebrow>
            </FadeUp>
            <FadeUp>
              <h2 data-testid="why-title" className="mt-7 leading-none text-burgundy">
                <span className="block font-serif font-semibold tracking-[-0.02em] text-4xl sm:text-5xl lg:text-6xl">
                  DAHA FAZLA PROFIL DEĞIL.
                </span>
                <span className="block font-pinyon text-5xl sm:text-6xl lg:text-7xl -mt-3 sm:-mt-4 lg:-mt-6 pl-10 sm:pl-16 lg:pl-24">
                  Daha iyi seçimler.
                </span>
              </h2>
            </FadeUp>
          </div>
          <FadeUp delay={0.2} className="lg:col-span-5 max-w-md text-base font-light text-ink-soft/90 leading-relaxed">
            Five Star&rsquo;da amaç sana mümkün olduğunca çok kişi göstermek değil. Seni, tercihlerini ve deneyimini
            anlayarak daha anlamlı seçimler sunmak.
          </FadeUp>
        </div>

        <div className="mt-16 sm:mt-24">
          {PRINCIPLES.map((p, i) => (
            <FadeUp key={p.n} delay={i * 0.1}>
              <div
                data-testid={`principle-${p.n}`}
                className="grid sm:grid-cols-12 gap-3 sm:gap-8 items-start border-t border-burgundy/10 py-9 sm:py-12"
              >
                <span className="sm:col-span-3 font-cinzel text-5xl sm:text-6xl text-burgundy/20 leading-none">{p.n}</span>
                <div className="sm:col-span-4">
                  <h3 className="font-serif text-2xl sm:text-3xl text-ink">{p.title}</h3>
                  {p.sub && <p className="mt-3 font-serif italic text-lg sm:text-xl text-burgundy leading-snug">{p.sub}</p>}
                </div>
                <div className="sm:col-span-5 space-y-4">
                  {p.paras.map((t, k) => (
                    <p key={k} className="text-[15px] font-light text-ink-soft/90 leading-relaxed">{t}</p>
                  ))}
                </div>
              </div>
            </FadeUp>
          ))}
          <div className="border-t border-burgundy/10" />
        </div>
      </div>
    </section>
  );
}
